// Header.tsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeadset } from '@fortawesome/pro-regular-svg-icons';
import { ReactComponent as RaiseRightLogo } from '../../media/images/RaiseRightLogo.svg';
import { createStyles } from 'utils/createStyle';
import { Routes } from 'routes';

interface HeaderProps {
    onExit: (location?: string) => void;
}

const Header = ({ onExit }: HeaderProps) => {
    const headerStyles = createStyles({
        header: [
            'relative w-full sm:flex bg-white border border-b-1 border-grey-line',
            { height: '68px' },
        ],
        headerLink: [
            ` no-underline brand px-5 py-1 -mt-0.5 mx-5 text-sm font-semibold rounded-full hover:border-1 hover:bg-pale-blue focus:outline-pale-blue active:bg-pale-blue`,
            { fontSize: '14px', height: 40 },
        ],
        headerExit: [
            'text-brand rounded-full leading-snug border font-semibold text-sm border-grey-light hover:border-brand focus:outline-pale-blue active:bg-pale-blue tracking-wider',
            { width: 80, height: 40 },
        ],
        supportIcon: ['mr-2', { fontSize: '24px', position: 'relative', top: '4px' }],
        seperator: ['h-6 w-1 border-r ml-4 mr-6', { height: '40px', borderColor: '#E9E9E9' }],
        leftHeader: 'flex items-center justify-start w-1/2 pl-8',
        rightHeader: 'flex items-center justify-end w-1/2 pr-6',
    });

    return (
        <div className={headerStyles.header}>
            <div className={headerStyles.leftHeader}>
                <button
                    className="outline-none focus:outline-none"
                    onClick={() => onExit(Routes.Shop)}
                >
                    <RaiseRightLogo width="168" height="30" />
                </button>
            </div>

            <div className={headerStyles.rightHeader}>
                <a
                    target="_blank"
                    className={headerStyles.headerLink}
                    href={'https://www.raiseright.com/about-us/contact/'}
                >
                    <FontAwesomeIcon icon={faHeadset} className={headerStyles.supportIcon} />
                    Customer Support
                </a>

                <div className={headerStyles.seperator}></div>

                <button className={headerStyles.headerExit} onClick={() => onExit()}>
                    EXIT
                </button>
            </div>
        </div>
    );
};

export default Header;
